import React, { Component } from "react";

export class PageTitle extends Component {
  render() {
    return (
            <h1 style={{ overflowWrap: "anywhere" }}>{this.props.title}</h1>
    );
  }
}
